import React, { useEffect, useState } from "react"
import { Card, CardBody } from "reactstrap"

import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"

import { CountsheetListing, WarehouseListing } from "api/api.service"
import { AutoComplete } from "components/AutoComplete"
import { Button } from "components/Button"
import { DataTable } from "components/DataTable"
import { Modal } from "components/Modal"
import { Pagination } from "components/Pagination"
import { SearchBox } from "components/SearchBox"
import { TextInput } from "components/TextInput"
import useAsyncSelect from "hooks/useAsyncSelect"
import { useLocalPaginatedRequest } from "hooks/useLocalPaginatedRequest"
import { updateObjCheckBox } from "utils/commonUtils"
import ItemDetails from "./ItemDetails"
import WarehouseBulkCommitDetailModal from "./Modal/WarehouseBulkCommitDetailModal"

import ActionEyeIcon from "assets/images/icons/feather-eye-icon.png"

const DATA_KEY = "data"
const TOTAL_KEY = "total"

const COLUMNS = {
   SKU_NO: "SKU No.",
   ITEM_NAME: "Item Name",
   AUDITS: "Audit Count",
   ACTION: "Action",
   SELECT_ALL: "Select All",
   AUDIT_QUANTITY: "Audit Quantity",
   ACTUAL_QUANTITY: "Actual Quantity",
}
const initialModalValue = {
   isBulkCommit: false,
   isView: false,
   type: null,
}
const modalTypes = {
   BULK_COMMIT: "BULK_COMMIT",
   VIEW: "VIEW",
}

const Listing = () => {
   const [filters, setFilters] = useState(null)
   const [selectedItemToView, setSelectedItemToView] = useState("")
   const [modalDataList, setModalDataList] = useState([])
   const [isSelectAll, setIsSelectAll] = useState(false)
   const [modalStates, setModalStates] = useState(initialModalValue)
   const WarehouseIds = filters ? filters.map(id => id) : []

   const {
      page,
      searchText,
      handleSearchChange,
      handlePageClick,
      pageSize,
      onChangePageSize,
      data,
      total,
      isFetching,
      request,
   } = useLocalPaginatedRequest({
      requestFn: CountsheetListing,
      params: {
         ...(filters?.length && { departmentId: filters }),
         auditCategory: "Warehouse",
      },
      deps: [filters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })
   let dataLength = data?.length
   const {
      setSelectedOption: setSelectedStationOption,
      selectEntity: stationOptions,
      setSelectEntity: setStationsOption,
      handleSearchOnOptions: handleSearchStations,
      selectedOption: selectedStation,
      handleSelectAOption: handleSelectAStationOption,
   } = useAsyncSelect({
      apiFunc: WarehouseListing,
      labelKey: "warehouseName",
      valueKey: "id",
      onOptionSelect: option => {
         const ids = option.map(item => item.value)
         setFilters(ids)
      },
   })
   useEffect(() => {
      setIsSelectAll(false)
      setModalDataList([])
   }, [data])

   const handleCloseModal = () => {
      setModalStates(initialModalValue)
      setSelectedItemToView("")
   }

   const handleSelectedItem = item => {
      setSelectedItemToView(item)
      setModalStates({
         ...modalStates,
         isView: true,
         type: modalTypes.VIEW,
      })
   }

   const handleBulkCommit = () => {
      setModalStates({
         ...modalStates,
         isBulkCommit: true,
         type: modalTypes.BULK_COMMIT,
      })
   }
   const handleCheckBoxSelect = (e, item) => {
      const dataTemp = updateObjCheckBox(item, modalDataList, "itemsId")
      let filteredData = data.filter(el => el?.maxQuantity > 0)

      isSelectAll &&
         dataTemp.length !== filteredData.length &&
         setIsSelectAll(false)
      !isSelectAll &&
         dataTemp.length === filteredData.length &&
         setIsSelectAll(true)
      setModalDataList(dataTemp)
   }
   // select all handler
   const handleSelectAll = () => {
      let filteredData = data.filter(el => el.maxQuantity > 0)
      isSelectAll ? setModalDataList([]) : setModalDataList(filteredData)
      setIsSelectAll(!isSelectAll)
   }
   return (
      <>
         <Card className="mb-5">
            <CardBody className="p-2 p-md-4 wh-im-wh-gi-con">
               <div className="mb-3">
                  <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
                     <div className="status-search-con wh-im-dpgi-status">
                        <AutoComplete
                           handleBlur={() =>
                              setStationsOption(prev => {
                                 return {
                                    ...prev,
                                    page: 1,
                                    Q: "",
                                 }
                              })
                           }
                           onChange={handleSelectAStationOption}
                           onInputChange={handleSearchStations}
                           placeholder="Select warehouse"
                           classNamePrefix="status-header-search-admin"
                           customStyles={autoCompleteStyles.STYLE_ONE}
                           options={stationOptions?.data}
                           value={selectedStation}
                           isLoading={stationOptions?.fetching}
                           maxMenuHeight={210}
                           isMulti
                        />
                     </div>
                     <div className="ad-location-search-box d-flex flex-row gap-3">
                        <Button
                           // isLoading={isLoading}
                           type={"submit"}
                           title={"Bulk Commit"}
                           className="header-button"
                           onClick={handleBulkCommit}
                           disabled={modalDataList?.length === 0}
                        />
                        <SearchBox
                           inputClasses="vendor-search-input input-search"
                           labelClass="d-none"
                           placeholder="Search"
                           searchIcon={true}
                           searchIconClass="vendor-table-search-icon"
                           conClass="vendor-table-search-inner-class"
                           searchText={searchText}
                           onChange={handleSearchChange}
                        />
                     </div>
                  </div>
               </div>
               <DataTable
                  data={data}
                  tableClasses="ad-warehouse-general-inventory-table "
                  loading={isFetching}
                  config={[
                     {
                        title: COLUMNS.SELECT_ALL,
                        selectAll: true,
                        selectAllClickHandler: handleSelectAll,
                        isSelectAll: isSelectAll,
                        thClass: "checkbox-header",
                        tdClass: "checkbox-column",
                        className: "checkbox-column",
                        isDisabled: !dataLength,
                        render: data => {
                           return (
                              <TextInput
                                 onClick={e => handleCheckBoxSelect(e, data)}
                                 labelClass="mb-0 "
                                 type="checkbox"
                                 inputClass="form-check-input-custom fm-table-checkboxes"
                                 checked={
                                    modalDataList.length > 0
                                       ? modalDataList.filter(
                                            el => el.itemsId === data.itemsId
                                         ).length
                                       : false
                                 }
                                 disabled={data?.maxQuantity < 0}
                              />
                           )
                        },
                     },
                     {
                        title: COLUMNS.SKU_NO,
                        render: item => item.skuNo,
                     },
                     {
                        title: COLUMNS.ITEM_NAME,
                        render: item => item.itemName,
                     },
                     {
                        title: COLUMNS.ACTUAL_QUANTITY,
                        render: item => item?.totalActualQuantity,
                     },
                     {
                        title: COLUMNS.AUDIT_QUANTITY,
                        render: item => item?.totalAuditQuantity,
                     },

                     {
                        title: COLUMNS.AUDITS,
                        render: item => item.totalAudits,
                     },

                     {
                        title: COLUMNS.ACTION,
                        render: item => (
                           <div className="d-flex align-items-center justify-content-center gap-4">
                              <img
                                 src={ActionEyeIcon}
                                 alt="view"
                                 className="cursor-pointer"
                                 onClick={() => handleSelectedItem(item)}
                              />
                           </div>
                        ),
                     },
                  ]}
               />
               <Pagination
                  currentPage={page}
                  totalData={total}
                  onPageClick={handlePageClick}
                  rowLimit={pageSize}
                  onChangePageSize={onChangePageSize}
               />
            </CardBody>
         </Card>
         {modalStates.isView && modalStates.type === modalTypes.VIEW && (
            <Modal
               isOpen={
                  modalStates.isView && modalStates.type === modalTypes.VIEW
               }
               handleModalToggling={handleCloseModal}
               sizeClasses="10"
               bodyClassName="p-0"
               customButton={true}
               hideModalHeaderSeparator={true}
               headerClasses="pb-0"
               className="inv-req-popup-viewdetails"
            >
               <ItemDetails
                  auditFor="Warehouse"
                  itemsId={selectedItemToView.itemsId}
                  warehouseId={filters?.[0]}
                  name={"warehouse"}
                  subKey={"warehouseName"}
               />
            </Modal>
         )}

         {modalStates.isBulkCommit &&
            modalStates.type === modalTypes.BULK_COMMIT && (
               <WarehouseBulkCommitDetailModal
                  isOpen={
                     modalStates.isBulkCommit &&
                     modalStates.type === modalTypes.BULK_COMMIT
                  }
                  actionName="Save"
                  entityName="Bulk Commit"
                  toggleFunction={() => handleCloseModal()}
                  selectedItemsData={modalDataList}
                  WarehouseIds={WarehouseIds}
                  request={request}
               />
            )}
      </>
   )
}

export default Listing
